import React from 'react';
import { Button, Text } from 'reaxl';

function MyWalletWelcomeMessage({ onGetStartedClick, ...rest }) {
    return (
        <div {...rest}>
            <Text>
                See payments tailored to you, estimated loan rates, and budget tools to customize your shopping
                experience.&nbsp;&nbsp;
                <Button
                    bsStyle="default"
                    bsSize="small"
                    onClick={onGetStartedClick}
                >
                    Get Started
                </Button>
            </Text>
        </div>
    );
}

export default MyWalletWelcomeMessage;
